import { Grid } from '@mui/material';
import ActionButton from 'components/buttons/index';
import { styles } from './styles';

export const ModalFooter = ({
  isLoading,
  onClose,
  onSubmit,
}: {
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  return (
    <Grid sx={styles.actionButtonsContainer}>
      <ActionButton
        label="Cancel"
        type="button"
        variant="secondary"
        style={styles.cancelButton}
        onClick={onClose}
        disabled={isLoading}
      />
      <ActionButton
        label="Save"
        type="button"
        onClick={onSubmit}
        variant="primary"
        style={styles.actionButton}
        loading={isLoading}
      />
    </Grid>
  );
};
